import axios from "axios";
import { ICountry } from "../models/Country";

class CountryServiceClass {
  async getCountries() {
    return await axios.get<ICountry[]>("https://restcountries.com/v3.1/all?fields=name,idd,cca2");
  }
}

export const CountryService = new CountryServiceClass();
